var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.downloadLoading,
          expression: "downloadLoading",
        },
      ],
      staticClass: "task-config-container",
    },
    [
      _c(
        "div",
        { staticClass: "list-container" },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "220px" },
                      attrs: { placeholder: "选择活动", clearable: "" },
                      model: {
                        value: _vm.searchForm.activityId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "activityId", $$v)
                        },
                        expression: "searchForm.activityId",
                      },
                    },
                    _vm._l(_vm.actList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.activityName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入兑换码", clearable: "" },
                    model: {
                      value: _vm.searchForm.exchangeCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "exchangeCode", $$v)
                      },
                      expression: "searchForm.exchangeCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入手机号", clearable: "" },
                    model: {
                      value: _vm.searchForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "mobile", $$v)
                      },
                      expression: "searchForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入会员卡号", clearable: "" },
                    model: {
                      value: _vm.searchForm.cardNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "cardNo", $$v)
                      },
                      expression: "searchForm.cardNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "兑换状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "未兑换", value: "0" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已兑换", value: "1" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择兑换门店",
                      },
                      model: {
                        value: _vm.searchForm.storeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "storeId", $$v)
                        },
                        expression: "searchForm.storeId",
                      },
                    },
                    _vm._l(_vm.shoplist, function (group) {
                      return _c(
                        "el-option-group",
                        {
                          key: group.regionId,
                          attrs: { label: group.regionName },
                        },
                        _vm._l(group.dealerList, function (item) {
                          return _c("el-option", {
                            key: item.dealerId,
                            attrs: {
                              label: item.dealerName,
                              value: item.dealerId,
                            },
                          })
                        }),
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fetchList },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.download } },
                    [_vm._v("导出")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                border: "",
                "element-loading-text": "数据加载中...",
                "element-loading-spinner": "el-icon-loading",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "编号",
                  width: "60",
                  align: "center",
                  index: _vm.indexMethod,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "activityName",
                  label: "活动名称",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "exchangeCode",
                  label: "兑换码",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "兑换门店",
                  prop: "exchangeStoreName",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: "手机号", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "会员卡号", prop: "cardNo", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "兑换状态",
                  prop: "statusName",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "兑换时间",
                  prop: "exchangeTimeFmt",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("优惠券明细")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.searchForm.total,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "user-dialog",
          attrs: {
            title: "优惠券列表",
            "close-on-click-modal": true,
            visible: _vm.showUserDialog,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showUserDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.couponList, border: "" } },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "编号",
                  width: "60",
                  align: "center",
                  index: _vm.indexMethod,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "couponName", label: "券名称", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "couponId", label: "券ID", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponNum",
                  label: "数量",
                  width: "60",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "核销订单号",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderStore",
                  label: "核销门店",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "verifyStatus",
                  label: "核销状态",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.verifyStatus == "0"
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("未核销"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.verifyStatus == "1"
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v("已核销"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { float: "right", "margin-top": "20px" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm2.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm2.limit,
                  total: _vm.searchForm2.total,
                },
                on: {
                  "current-change": _vm.handlePageChange2,
                  "size-change": _vm.handleSizeChange2,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }